<template>
  <li class="at-userbar">
    <figure class="at-userbar_profile">
      <span v-if="userProps.isOnline" class="at-userstatus online"></span>
      <img :src="userProps.userAvatar ? userProps.userAvatar : defaultAvatar" :alt="userProps.userName" />
    </figure>
    <div v-if="userProps.userName" class="at-userbar_title">
      <h3>{{ textCapitalize(userProps.userName)}}</h3>
    </div>
    <div class="at-userbar_right">
      <!-- for atuo start chat invite button -->
      <a v-if="autoInvite" class="at-btn-sm at-linebtn" :class="{'at-disable-btn' : isLoading }" href="javascript:void(0);" @click.prevent="updateUserStatus(1)"> {{TRANS.start_chat_txt}} </a>
      <a  v-else href="javascript:void(0);" @click.prevent="updateUserStatus(0)" class="at-btn-sm" 
        :class=" 
          isLoading ? 'at-disable-btn' :
          userProps.statusText == 'sent'    ? 'at-disabled' : 
          userProps.statusText == 'respond' ? 'at-btn-respond' : 
          userProps.statusText == 'resend'  ? 'at-btn-resend' : 
          userProps.statusText == 'invite'  ? '' : ''" >
          {{StatusText[userProps.statusText]}}
          <span class="at-infotolltip" v-if="userProps.statusText == 'resend' ">
            <i class="guppy-info"></i><em>{{TRANS.decline_user}}</em>
          </span>
      </a>
    </div>
  </li>
</template>

<script>
import { GUPPYCHAT_CONSTANTS, GUPPYCHAT_SETTINGS } from "../../../resources/constants";
import GuppyChatManager from "../../../resources/controller";
import { mapState } from 'vuex';

export default {
    name : "GuppyChatUserListItem",
    props: ['userProps'],
    data(){
      return {
        defaultAvatar : GUPPYCHAT_CONSTANTS.AVATAR,
        isDisabled  : false,
        userStatusClass : '',
        oldVal : ''
      }
    },
    computed :{ ...mapState({
      autoInvite: state => state.autoInvite,
      isMessangerChat: state => state.isMessangerChat,
      }),
    },
    methods:{
      textCapitalize(text){
        return GuppyChatManager.usFirst(text);
      },
      async updateUserStatus(startChat){
        if( this.userProps.statusText == 'respond' && !startChat){
          this.$store.dispatch('userResponse', this.userProps);
          if(!this.isMessangerChat){
            this.$root.$emit('openPopUp', { type : 'acceptInvite' });
          }
        } else {
          let data = {
            'sendTo'       : this.userProps.chatId.split('_')[0],
            'userId'       : this.userId,
            'startChat'    : startChat
          }
          this.isLoading = true;
          let response = await GuppyChatManager.sendGuppyInvite(data);
          if(response){
            this.isLoading = false;
            if( response.data.type == "success" ) {
              if(response.data.autoInvite){
                if(!GUPPYCHAT_SETTINGS.pusherEnable && !GUPPYCHAT_SETTINGS.socketEnable){
                  this.$store.commit('startChat', { friendData: response.data.friendData, messagelistData : response.data.messagelistData } );
                } else {
                  if(startChat){
                    this.$store.commit('removeContactListItem', {chatId : this.userProps.chatId } );
                  }
                }
              }
              this.userProps.statusText = 'sent';
              this.userStatusClass      = 'at-disabled';
              this.isDisabled = true;
            }
          }
        }
      }
    }
};
</script>

<style>
.at-userbar {
  padding: 20px !important;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.at-userbar.active .at-userbar_profile,
.at-userbar:hover .at-userbar_profile{background: #fff;}
.at-userbar.active,
.at-userbar:hover {
  background: #F7F7F7;
}
.at-userbar_profile {
  flex: none;
  width: 100%;
  max-width: 50px;
  height: 50px;
  border-radius: 50px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
  transition: all 0.3s ease-in-out;
  position: relative;
}
.at-userbar_profile .at-userstatus{
  right: 0;
  bottom: 0;
  z-index: 1;
  position: absolute;
}
.at-userbar_profile .at-userstatus:before{
  margin: 0;
  width: 14px;
  height: 14px;
  border: 2px solid #fff;
}
.at-userbar.active .at-userbar_profile .at-userstatus:before,
.at-userbar:hover .at-userbar_profile .at-userstatus:before{
  border-color: #f7f7f7;  
}
.at-userbar_profile .at-userstatus:before{background: #DDDDDD;}
.at-userbar_profile img {
  width: 100%;
  margin: 0 auto;
  height: 50px;
  display: block;
  object-fit: cover;
  border-radius: 50px !important;
}
.at-userbar_profile + .at-userbar_title{
  margin-left: 15px;
}
.at-userbar_title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.at-userbar_title h3 {
  font-size: 18px;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
}
.at-userbar_title span {
  font-size: 14px;
  line-height: 26px;
  display: block;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.at-userbar_title span i {
  font-size: 16px;
  color: var(--terguppycolor);
  margin-right: 5px;
  line-height: 22px;
  display: inline-block;
  vertical-align: middle;
}
.at-userbar_right {
  text-align: right;
  margin-left: auto;
  flex: none;
  padding-left: 10px;
}
.at-userbar_right a{text-decoration: none !important;}
.at-userbar_right > span {
  display: block;
  font-size: 14px;
  line-height: 24px;
  color: var(--terguppycolor);
}
.at-userbar:hover .at-disabled {
  background-color: #fff;
}
.at-userlist_tab li + li {
  border-top: 1px solid #ddd;
}
</style>